module.exports = "<lui-overlay seedelement>\n  <lui-notification open variant=\"lightbox\">\n    <slot name=\"title\" slot=\"title\"></slot>\n    <slot name=\"bodytext\" slot=\"bodytext\"></slot>\n    <lui-button-group slot=\"controls\">\n      <slot name=\"controls\"></slot>\n    </lui-button-group>\n  </lui-notification>\n</lui-overlay>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-modalnotification/theme/lui-modalnotification.html
// module id = 278
// module chunks = 0 1 30